const google = (() => {
    return {
        openSignin      : openSignin,
        openDrivePost   : openDrivePost,
        driveInPost     : driveInPost,
    }

    function openSignin(url, title) {
        const props = {
            url,
            title,
            width: 600,
            height: 600,
            x: (window.screenLeft + ($(window).width() - 600) / 2),
            y: (window.screenTop + ($(window).height() - 600) / 2),
        }
        try {
            window.ElectronThirdpartyApi.google.openSignin(props);
        } catch(e) {
            Often.toast('error', i18next.t(main.alert.errorTryAgain));
        }
    }
    function openDrivePost(props) {
        try {
            window.ElectronThirdpartyApi.google.openDrivePost(props);
        } catch(e) {
            Often.toast('error', i18next.t(main.alert.errorTryAgain));
        }
    }
    function driveInPost(props) {
        try {
            window.ElectronThirdpartyApi.google.driveInPost(props);
        } catch(e) {
            Often.toast('error', i18next.t(main.alert.errorTryAgain));
        }
    }
})();

const memo = (() => {
    return {
        open    : open,
        set     : set,
    }

    function open(props) {
        try {
            window.ElectronThirdpartyApi.memo.open(props);
        } catch(e) {
            Often.toast('error', i18next.t(main.alert.errorTryAgain));
        }
    }
    function set(props) {
        try {
            return window.ElectronThirdpartyApi.memo.set(props);
        } catch(e) {
            Often.toast('error', i18next.t(main.alert.errorTryAgain));
        }
    }
})();

export {
    google,
    memo,
};